import script from "./control.vue?vue&type=script&setup=true&lang=ts"
export * from "./control.vue?vue&type=script&setup=true&lang=ts"

import "./control.vue?vue&type=style&index=0&id=7783da24&lang=scss"

const __exports__ = script;

export default __exports__